import React from "react";
import styled from "styled-components/macro";
import three_scooters_front_plan from "../../../images/ride/three_scooters_front_plan.png";
import four_scooters_front_plan from "../../../images/ride/four_scooters_front_plan.png";
import two_bike_front_plan from "../../../images/ride/two_bike_front.png";
import three_bike_front_plan from "../../../images/ride/three_bike_front.png";
import { device } from "../../device";

const RideUnitFrontlan = (props) => {
  const myWidth = () => {
    if ("scooter" === props.type) {
      if (props.size === "large") {
        return 542.5;
      } else {
        return 434;
      }
    } else if ("bicycle" === props.type) {
      if (props.size === "large") {
        return 542.5;
      } else {
        return 434;
      }
    }
  };

  const getHeightMargin = () => {
    // eslint-disable-next-line default-case
    switch (props.type) {
      case "scooter":
        if (props.size === 4) {
          return { top: 50, left: -1.5 };
        }
        return { top: 50, left: -1.5 };
      case "bicycle":
        if (props.size === 3) {
          return { top: 50, left: 0 };
        }
        return { top: 50, left: 0.5 };
    }
  };

  const getWidthMargin = () => {
    // eslint-disable-next-line default-case
    switch (props.type) {
      case "scooter":
        if (props.size === "large") {
          return { bottom: 10.2, left: 50.5 };
        }
        return { bottom: 11.2, left: 52 };
      case "bicycle":
        if (props.size === "large") {
          return { bottom: 11, left: 50.5 };
        }
        return { bottom: 11.2, left: 52 };
    }
  };

  const getImage = () => {
    switch (props.type) {
      case "scooter":
        if (props.size === "large") {
          return four_scooters_front_plan;
        }
        return three_scooters_front_plan;
      case "bicycle":
        if (props.size === "large") {
          return three_bike_front_plan;
        }
        return two_bike_front_plan;
      default:
        break;
    }
  };

  const getWidthBySize = () => {
    switch (props.type) {
      case "scooter":
        if (props.size === "large") {
          return 74.0;
        }
        return 56.5;
      case "bicycle":
        if (props.size === "large") {
          return 79.0;
        }
        return 54.0;
      default:
        break;
    }
  };

  return (
    <Wrapper>
      <Img src={getImage()} myHeight={375} myWidth={myWidth()} />
      <HeightSpan size={props.size} margin={getHeightMargin()}>
        {props.location === "us" ? "36.00" : "91.00"}
      </HeightSpan>
      <WidthSpan size={props.size} margin={getWidthMargin()}>
        {props.location === "us"
          ? getWidthBySize().toFixed(2)
          : Math.ceil(getWidthBySize() * 2.54).toFixed(2)}
      </WidthSpan>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
  width: fit-content;
  margin-bottom: 24px;
`;

const Img = styled.img`
  @media ${device.mobileS} {
    height: ${({ myHeight }) => myHeight}px;
    width: ${({ myWidth }) => myWidth}px;
    max-width: none;
  }
  @media ${device.tablet} {
    height: ${({ myHeight }) => myHeight}px;
    width: ${({ myWidth }) => myWidth}px;
    max-width: 100%;
  }
`;

const HeightSpan = styled.span`
  position: absolute;
  font-family: DMSans;
  font-size: 13px;
  top: 42%;
  left: 0;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.54;
  letter-spacing: normal;
  text-align: center;
  color: #6d6e6e;
`;

const WidthSpan = styled.span`
  position: absolute;
  font-family: DMSans;
  font-size: 13px;
  bottom: 14px;
  left: 55.5%;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.54;
  letter-spacing: normal;
  text-align: center;
  color: #6d6e6e;
`;

export default RideUnitFrontlan;
